import { useState } from "react";

import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";

import { Button, Hairline, Input, Label, Radio } from "@components";
import { CurrencyInput } from "@components/CurrencyInput";

export default ({ node, input_configs, onSave, onRemove }) => {
  const [operand, setOperand] = useState(node.operand || "eq");
  const [value, setValue] = useState(node.value);

  const getFreshNode = () => {
    return { ...node, operand, value };
  };

  const validate = () => {
    const { min, max, type } = input_configs || {};

    if (!operand && !value) {
      return false;
    }

    if (["currency", "number"].includes(type)) {
      if (min != undefined && +value < min) {
        return false;
      }

      if (max != undefined && +value > max) {
        return false;
      }
    }

    return true;
  };

  const is_number = ["currency", "number"].includes(input_configs?.type);
  const InputComponent = is_number ? CurrencyInput : Input;

  return (
    <>
      <div className={styles.scrollContainer}>
        <div className={styles.card}>
          <Label>Defina o uso desta variável:</Label>
          <Hairline solid className="mt-5 mb-20" />
          <Radio
            family="variableType"
            className="mb-10"
            value="eq"
            checked={operand}
            onChange={() => setOperand("eq")}
          >
            Igual a
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="neq"
            checked={operand}
            onChange={() => setOperand("neq")}
          >
            Diferente de
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="like"
            checked={operand}
            onChange={() => setOperand("like")}
          >
            Contém
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="starts"
            checked={operand}
            onChange={() => setOperand("starts")}
          >
            Inicia com
          </Radio>
          <Radio
            family="variableType"
            value="ends"
            checked={operand}
            onChange={() => setOperand("ends")}
          >
            Termina com
          </Radio>
        </div>

        <div className={styles.card}>
          <Label>Determine o valor de comparação:</Label>
          <Hairline solid className="mt-10 mb-20" />
          <InputComponent
            value={value}
            onChange={(e, m, v) => {
              const value = is_number ? v : e === null ? "" : e.target.value;
              setValue(value);
            }}
            className="mb-0"
            {...input_configs}
          />
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          className="w-100"
          onClick={() => onSave(getFreshNode())}
          disabled={!validate()}
          design="primary"
        >
          Aplicar
        </Button>
        <Button
          design="underline"
          className="mt-20 mb-10"
          onClick={() => onRemove(getFreshNode())}
        >
          Remover comparação
        </Button>
      </div>
    </>
  );
};
